import React, { useState } from 'react';
// import SalesStatisticOne from './child/SalesStatisticOne';
// import TotalSubscriberOne from './child/TotalSubscriberOne';
// import UsersOverviewOne from './child/UsersOverviewOne';
// import BalanceStatistic from './child/BalanceStatistic';
import MapComponent from './child/MapComponent';
// import UnitCountOne from './child/UnitCountOne';
import DashboardProvinceCards from './child/DashboardProvinceCards';
import BannerInnerOne from './child/BannerInnerOne';
import UsersOverviewOneProvinces from './child/UsersOverviewOneProvinces';
import EarningStatisticTwo from './child/EarningStatisticTwo';
// import ComplaintSourcesChartsModal from './child/ComplaintSourcesChartsModal';
import DashboardPublicDetailsModal from './child/DashboardPublicDetailsModal'; // Ensure this import exists
import DashboardDeptDetailsModal from './child/DashboardDeptDetailsModal'; // Ensure this import exists


const DashBoardLayerOne = () => {
  const [showDeptDetails, setShowDeptDetails] = useState(false);
  const [showPublicDetails, setShowPublicDetails] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState(null);

  const handleViewDeptDetails = (province) => {
    setSelectedProvince(province);
    setShowDeptDetails(true);
  };

  const handleViewPublicDetails = (province) => {
    setSelectedProvince(province);
    setShowPublicDetails(true);
  };

  const handleCloseModals = () => {
    setShowDeptDetails(false);
    setShowPublicDetails(false);
    setSelectedProvince(null);
  };

  return (
    <>
      <BannerInnerOne />
      
      <DashboardProvinceCards 
        onViewDeptDetails={handleViewDeptDetails} 
        onViewPublicDetails={handleViewPublicDetails} 
      />
      <div className="container-fluid">
      <div className="row">
        <UsersOverviewOneProvinces />
        <EarningStatisticTwo />
        
      </div>
    </div>
      
      <section className="row gy-4 mt-1">
        {/* <BalanceStatistic  /> */}
        <MapComponent />
      </section>

      <DashboardPublicDetailsModal 
        show={showPublicDetails} 
        handleClose={handleCloseModals}
        province={selectedProvince}
      />
      <DashboardDeptDetailsModal 
        show={showDeptDetails} 
        handleClose={handleCloseModals}
        province={selectedProvince}
      />
    </>
  );
}
// const DashBoardLayerOne = () => {
//   const [showDeptDetails, setShowDeptDetails] = useState(false);
//   const [showPublicDetails, setShowPublicDetails] = useState(false);

//   return (
//     <>
//       <BannerInnerOne />
//       {/* UnitCountOne */}
//       {/* <UnitCountOne /> */}
//       <DashboardProvinceCards 
//         onViewDeptDetails={() => setShowDeptDetails(true)} 
//         onViewPublicDetails={() => setShowPublicDetails(true)} 
//       />
//       <section className="row gy-4 mt-1">
//         {/* SalesStatisticOne */}
//         {/* <SalesStatisticOne onViewAllSources={() => setShowSourcesModal(true)} /> */}

//         {/* TotalSubscriberOne */}
//         {/* <TotalSubscriberOne /> */}

//         {/* UsersOverviewOne */}
//         {/* <UsersOverviewOne /> */}
        
//         {/* MapComponent */}
//         <MapComponent />
 
//         {/* GeneratedContent */}
//         {/* <GeneratedContent /> */}
//       </section>

//       {/* Complaint Sources Modal */}
//       {/* <ComplaintSourcesChartsModal 
//         show={showSourcesModal} 
//         handleClose={() => setShowDeptDetails(false)} 
//       /> */}
//       <DashboardPublicDetailsModal 
//         show={showPublicDetails} 
//         handleClose={() => setShowPublicDetails(false)} 
//       />
//       <DashboardDeptDetailsModal 
//         show={showDeptDetails} 
//         handleClose={() => setShowDeptDetails(false)} 
//       />
//     </>
//   );
// }

 export default DashBoardLayerOne;

